import React from 'react';
import { Star, Shield, MapPin } from 'lucide-react';

const HostSection = ({ property }) => {
  const hostReviews = [
    {
      name: "Karen",
      date: "1 week ago",
      text: "Susanna was friendly, very responsive and welcoming. Beautiful location, very peaceful. The loft was very clean and presented lovely we weren't there for a holiday but I can imagine the walks would be wonderful",
      avatar: "/images/karen-pfp.webp"
    },
    {
      name: "Jan",
      date: "August 2025",
      text: "Susanna was so kind and lovely! And her place is so beautiful and peaceful. We left truly relaxed and eager to come back.",
      avatar: "/images/jan-pfp.webp"
    },
    {
      name: "Sam",
      location: "London, United Kingdom",
      date: "August 2025",
      text: "Fantastic stay. Sussanna was hugely kind to us",
      avatar: "/images/sam-pfp.webp"
    }
  ];

  return (
    <section className="py-10 md:py-16 px-4 md:px-6 bg-[#FAF7F2] border-t border-border/50">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12">
          
          {/* Left - Host Card */}
          <div className="flex flex-col sm:flex-row gap-6 md:gap-8">
            {/* Host profile card */}
            <div className="bg-white rounded-3xl shadow-lg border border-gray-100 p-6 md:p-8 text-center flex-shrink-0 w-full sm:w-56 md:w-64">
              {/* Avatar with shield badge */}
              <div className="relative inline-block mb-4">
                <div className="w-20 h-20 md:w-28 md:h-28 rounded-full overflow-hidden mx-auto border-4 border-white shadow-md">
                  <img 
                    src="/images/susanna-pfp.webp"
                    alt="Susanna"
                    className="w-full h-full object-cover"
                  />
                </div>
                {/* Shield with checkmark badge */}
                <div className="absolute bottom-0 right-2 md:right-4 w-7 h-7 md:w-9 md:h-9 bg-[#FF385C] rounded-full flex items-center justify-center shadow-md">
                  <svg className="w-4 h-4 md:w-5 md:h-5" viewBox="0 0 24 24" fill="none">
                    {/* Shield */}
                    <path d="M12 2L4 6V11C4 16.5 7.5 21.5 12 23C16.5 21.5 20 16.5 20 11V6L12 2Z" fill="white"/>
                    {/* Checkmark */}
                    <path d="M9 12L11 14L15 10" stroke="#FF385C" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
              
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-1" style={{fontFamily: 'Cormorant Garamond, Georgia, serif'}}>
                Susanna
              </h3>
              <p className="text-gray-500 text-xs md:text-sm mb-4 md:mb-6">Host</p>
              
              {/* Stats - Colorful and trustworthy */}
              <div className="space-y-3 md:space-y-4 text-left">
                {/* Reviews */}
                <div className="flex items-center justify-between border-b border-gray-100 pb-2 md:pb-3">
                  <div className="flex items-center gap-2">
                    <span className="text-xl md:text-2xl font-bold bg-gradient-to-r from-[#FF385C] to-[#E31C5F] bg-clip-text text-transparent" style={{fontFamily: 'Cormorant Garamond, Georgia, serif'}}>216</span>
                  </div>
                  <span className="text-[10px] md:text-xs font-medium text-[#FF385C] uppercase tracking-wide">Reviews</span>
                </div>
                {/* Rating */}
                <div className="flex items-center justify-between border-b border-gray-100 pb-2 md:pb-3">
                  <div className="flex items-center gap-1 md:gap-1.5">
                    <span className="text-xl md:text-2xl font-bold text-[#00A699]" style={{fontFamily: 'Cormorant Garamond, Georgia, serif'}}>4.99</span>
                    <Star className="w-4 h-4 md:w-5 md:h-5 fill-[#FFB400] text-[#FFB400]" />
                  </div>
                  <span className="text-[10px] md:text-xs font-medium text-[#00A699] uppercase tracking-wide">Rating</span>
                </div>
                {/* Years hosting */}
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <span className="text-xl md:text-2xl font-bold text-[#484848]" style={{fontFamily: 'Cormorant Garamond, Georgia, serif'}}>10</span>
                  </div>
                  <span className="text-[10px] md:text-xs font-medium text-[#767676] uppercase tracking-wide">Years hosting</span>
                </div>
              </div>
            </div>

            {/* About host */}
            <div className="flex-1">
              <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground mb-4 md:mb-6" style={{fontFamily: 'Cormorant Garamond, Georgia, serif'}}>
                About Susanna
              </h2>
              
              <div className="space-y-3 md:space-y-4 mb-4 md:mb-6">
                <div className="flex items-center gap-2 md:gap-3 text-gray-700 text-sm md:text-base">
                  <MapPin className="w-4 h-4 md:w-5 md:h-5 text-gray-400" />
                  <span>Lives in Balcombe, United Kingdom</span>
                </div>
                <div className="flex items-center gap-2 md:gap-3 text-gray-700 text-sm md:text-base">
                  <Shield className="w-4 h-4 md:w-5 md:h-5 text-gray-400" />
                  <span>Identity verified</span>
                </div>
              </div>
              
              <p className="text-gray-700 leading-relaxed mb-4 md:mb-6 text-sm md:text-base">
                Wife, mother and Personal Organiser!
              </p>

              <a 
                href="https://www.airbnb.co.uk/users/profile/1462898354019480359?previous_page_name=PdpHomeMarketplace"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block text-primary font-semibold underline hover:text-primary/80 transition-colors text-sm md:text-base"
                onClick={() => { if (window.va) window.va('event', { name: 'airbnb_click', data: { location: 'host_profile' } }); }}
              >
                View full profile on Airbnb
              </a>
            </div>
          </div>

          {/* Right - Host Reviews */}
          <div>
            <h3 className="text-lg md:text-xl font-semibold text-foreground mb-4 md:mb-6" style={{fontFamily: 'Cormorant Garamond, Georgia, serif'}}>
              Some of Susanna's reviews:
            </h3>
            
            <div className="space-y-4 md:space-y-6">
              {hostReviews.map((review, index) => (
                <div key={index} className="border-b border-gray-100 pb-4 md:pb-6 last:border-0">
                  <div className="flex items-center gap-2 md:gap-3 mb-2 md:mb-3">
                    <div className="w-10 h-10 md:w-12 md:h-12 rounded-full overflow-hidden">
                      <img 
                        src={review.avatar}
                        alt={review.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div>
                      <p className="font-semibold text-gray-900 text-sm md:text-base">{review.name}</p>
                      {review.location && (
                        <p className="text-[10px] md:text-xs text-gray-500">{review.location}</p>
                      )}
                    </div>
                  </div>
                  <div className="flex items-center gap-2 mb-2">
                    <div className="flex">
                      {[...Array(5)].map((_, i) => (
                        <Star key={i} className="w-2.5 h-2.5 md:w-3 md:h-3 fill-gray-900 text-gray-900" />
                      ))}
                    </div>
                    <span className="text-[10px] md:text-xs text-gray-500">· {review.date}</span>
                  </div>
                  <p className="text-gray-700 text-xs md:text-sm leading-relaxed">
                    {review.text}
                  </p>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HostSection;
